// layouts/auth-layout/auth-layout.component.ts
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageSwitcherComponent } from '../../shared/components/language-switcher/language-switcher.component';
import { LanguageChangeDirective } from '../../shared/directives/language-change.directive';

@Component({
    selector: 'app-auth-layout',
    standalone: true,
    imports: [RouterOutlet, LanguageSwitcherComponent, LanguageChangeDirective],
    template: `
        <div class="min-h-screen relative" appLanguageChange>
            <!-- Language Switcher in top right -->
            <div class="absolute top-4 right-4 z-10">
                <div class="bg-primary-500  rounded-sm">
                    <app-language-switcher></app-language-switcher>
                </div>
            </div>
            
            <!-- Main content -->
            <router-outlet />
        </div>
    `,
    styles: [`
        :host {
            display: block;
            width: 100%;
            height: 100vh;
        }
    `]
})
export class AuthLayoutComponent {}
